import { FC } from 'react';
import { Props } from './types';
import { StoreUtils } from 'utils/util';
import InteractiveAlertDialog from 'components/Dialoges/InteractiveAlertDialog';
import styles from './shiftManagement.module.scss';
import { DialogContentText } from '@mui/material';
import { useAppContext } from 'contexts/AppContext';
import { ShiftManagementService } from 'services/api/endpoints/shiftManagementService';
import { handleLogout } from 'utils/auth';
import { ApiError } from 'services/api/base';
import CurrencyDialog from './Dialoges/CurrencyDialog';

const ShiftManagement: FC<Props> = ({ open, onClose, popupData }) => {
  const { snack } = useAppContext();
  const shiftPermission = StoreUtils.getKeyFromActiveSession(['shiftPermission']);

  const handleEndShift = async () => {
    try {
      const data: { [key: string]: boolean } = { logout: true };
      const response = await ShiftManagementService.staffEndShift(data);
      const successMsg = response.data.data.userMessage;
      snack.show(successMsg, 'success');

      handleLogout(false);
      onClose();
    } catch (error) {
      snack.show((error as ApiError).userMessage, 'error');
      console.log(error);
    }
  };

  const handleLogoutAllUsers = async () => {
    try {
      const response = await ShiftManagementService.logOutAllSessions();
      const successMsg = response.data.data.userMessage;
      snack.show(successMsg, 'success');

      onClose();
    } catch (error) {
      snack.show((error as ApiError).userMessage, 'error');
      console.log(error);
    }
  };

  return shiftPermission ? (
    // Admin End shift Dialog
    popupData?.showCurrencyPopup ? (
      <CurrencyDialog open={open} shift={'end'} onSubmit={onClose} onClose={onClose} />
    ) : (
      <InteractiveAlertDialog
        open={open}
        title='Users Still Active'
        Body={() => (
          <DialogContentText className={styles.actionContentBox}>
            {popupData?.popupMsg}
          </DialogContentText>
        )}
        actions={[
          { label: 'Log out all users', variant: 'outlined', handler: handleLogoutAllUsers },
          { label: 'Continue', handler: onClose },
        ]}
      />
    )
  ) : (
    // Staff End Shift Dialog
    <InteractiveAlertDialog
      open={open}
      title='End Shift'
      Body={() => (
        <DialogContentText className={styles.actionContentBox}>
          Are you sure you want to end this Shift ?
        </DialogContentText>
      )}
      actions={[{ label: 'End Shift', handler: handleEndShift }]}
    />
  );
};
export default ShiftManagement;
